export default __webpack_public_path__ + "static/media/mintimg.d5f341c8.png";